import { useRpc } from "./_intlkit.tsx";

export interface FriendlyOdds {
  home: number; draw: number; away: number;
  over_25: number | null; under_25: number | null;
  btts_yes: number | null; btts_no: number | null;
}
export interface FriendlyFair {
  home: number; draw: number; away: number;
  prob_home: number; prob_draw: number; prob_away: number;
  over: number | null; under: number | null;
  prob_over: number; prob_under: number;
  btts_yes: number | null; btts_no: number | null;
  prob_btts_yes: number; prob_btts_no: number;
}
export interface FriendlyPick {
  selection: "home" | "draw" | "away";
  probability: number;
  edge_pct: number;
  composite: number;
  reasoning: string;
}
export interface FriendlyFixture {
  fixture_id: string;
  home_team: string;
  away_team: string;
  kickoff_at: string;
  status: string;
  odds: FriendlyOdds | null;
  fair: FriendlyFair | null;
  /** Composite pick from the moderator (prob + edge weighted) */
  pick: FriendlyPick | null;
}
export interface FriendlyDay { date: string; fixtures: FriendlyFixture[] }
export interface FriendlySignal {
  fixture_id: string; home_team: string; away_team: string;
  kickoff_at: string; market: string; selection: string;
  fair_odds: number; market_odds: number; fair_prob: number;
  edge_pct: number; clv_gap: number;
  /** null = not yet moderated, true = approved, false = rejected */
  mod_approved: boolean | null;
  mod_decision: string | null;
}
export interface FriendliesBoard {
  generated_at: string;
  total_fixtures: number;
  fixtures_with_odds: number;
  fixtures_with_prices: number;
  picks_count: number;
  /** Whether composite picks have been generated */
  moderated: boolean;
  days: FriendlyDay[];
  signals: FriendlySignal[];
}

export function useFriendliesBoard() {
  return useRpc<FriendliesBoard>("get_friendlies_board");
}
